export default {
      id: "ic-han-visual-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-han-visual-usage",
      toString: function () {
        return this.url;
      }
    }